import axios from 'axios';

const instance = axios.create();
instance.defaults.headers.post['Content-Type'] = 'application/json';

// axios拦截响应
instance.interceptors.response.use((response) => response, (err) => Promise.reject(err));

export default {
  // 获取问卷统计数据
  getStatistics(date) {
    return instance.get(`/api/survey/statistics?date=${date}`);
  },

  // 提交问卷
  submitSurvey(data) {
    return instance.post('/api/survey/submit', data);
  },

  // 获取问卷列表
  getSurveys() {
    return instance.post('/api/survey/getsurveys');
  },

  // 获取单个问卷/事件详情
  getEventById(id) {
    return instance.post('/api/survey/geteventbyid', { id });
  },

  // 删除问卷
  deleteSurvey(id) {
    return instance.post('/api/survey/deletesurvey', { id });
  },

  // 创建问卷
  createSurvey(data) {
    return instance.post('/api/survey/createsurvey', data);
  },

  // 更新问卷
  updateSurvey(data) {
    return instance.post('/api/survey/updatesurvey', data);
  },

  // 滿意度首頁摘要
  getHomeStats() {
    return instance.get('/api/survey/home-stats');
  },

  // 手動重建滿意度首頁摘要
  rebuildHomeStats(payload = {}) {
    return instance.post('/api/survey/home-stats/rebuild', payload);
  },
};
